import { useEffect, useState } from 'react';
import { useGlobal } from '../../context/GlobalContext';
import { getUiText } from '../../lib/uiText';
import styles from './ScrollTopButton.module.css';

const ScrollTopButton = () => {
  const { locale, header } = useGlobal();
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY <= 0);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    const footer = document.getElementById('site-footer');
    if (!footer || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsFooterVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );

    observer.observe(footer);
    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (isFooterVisible || isAtTop) {
    return null;
  }

  return (
    <button
      type="button"
      className={`${styles['scroll-top']} ${header?.textoOscuro ? styles['scroll-top--dark-text'] : ''}`.trim()}
      onClick={handleClick}
      aria-label={getUiText(locale, 'scrollTop')}
    >
      <span className={styles['scroll-top__icon-wrap']} aria-hidden="true">
        <svg
          className={styles['scroll-top__icon']}
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 20V4M5 11L12 4L19 11"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};

export default ScrollTopButton;
